import { createContext } from 'react'

export const TrackPrimaryLinks = createContext<{
  activeNavLink: string
}>({
  activeNavLink: '',
})
